import { useState, useMemo, useEffect } from 'react';
import filtericon from '../../assets/icons/mage_filter-fill.svg'
import '../../assets/css/StudentDashboard.css'
import '../../assets/css/Roles.css'
import SearchBar from '../../Component/SearchBar';
import { SuccessfulPopup } from '../../Component/Modals/SuccessfulPopup';
import Table from '../../Component/Table';
import edit from '../../assets/icons/pencil-square.svg';
import { useNavigate } from 'react-router-dom';
import { getData, patchData, Postdata, updateData } from '../../API/GlobalApi.js';
import { RolesAndPermissionsShortDetails } from './RolesAndPermissionsShortDetails.js';
import { AddDesignationModal } from '../../Component/Modals/AddDesignationModal.js';

const RolesAndPermissions = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpendept, setIsModalOpendept] = useState(false);
  const [submit, setsubmit] = useState(false);
  const [dnparentdata, setdnparentdata] = useState([]);
  const [orgdata, setorgdata] = useState([]);
  const [countryId, setcountryId] = useState(null);
  const [countrydata, setcountrydata] = useState([]);
  const [statedata, setstatedata] = useState([]);
  const [citydata, setcitydata] = useState([]);
  const [stateid, setstateid] = useState(null);
  const [cityid, setcityid] = useState(null);
  const [selectedOrgDetails, setSelectedOrgDetails] = useState([]);
  const [departmentdetails, setdepartmentdetails] = useState(null);
  const [parentidfromorg, setparentidfromorg] = useState(null)
  const [departmentidfromorg, setdepartmentidfromorg] = useState(null)
  const [departmentfromorg, setdepartmentfromorg] = useState([]);
  const [reporttofromorg, setreporttofromorg] = useState([]);
  const [Updatebtn, setUpdatebtn] = useState(false);
  const [parentorgid, setparentorgid] = useState(null);
  const [searchQuery, setSearchQuery] = useState('')
  const [orgform, setorgform] = useState({
    orgname: '',
    parentorgid: null,
    gstin: '',
    email: '',
    landlineno: '',
    mobileno: '',
    address: '',
    pincode: '',
    countrycode: '1'

  })
  const [deptform, setdeptform] = useState({
    name: "",
    reporttoid: null,
    id: null,
    orgid: null,
    deptid: null,
    status: null,
  })
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const isValidPhone = (phone) => /^\d{10}$/.test(phone);
  const isRequired = (val) => val && val.trim() !== '';
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');

  const displayToast = (message, variant = 'success') => {
    setToastMessage(message);
    setToastVariant(variant);
    setShowToast(true);

    setTimeout(() => setShowToast(false), 3000);
  };
  const handleRowClick = (orgId, row) => {
    let selectedOrg = null;


    if (row.original.id === orgId) {
      selectedOrg = row.original;
    }


    if (selectedOrg) {
      const { id, name, parent, email, organization_id } = selectedOrg;
      setSelectedOrgDetails(selectedOrg);
      getdeptdata(id);
      setparentidfromorg(organization_id);

      localStorage.setItem('selectedOrgDetails', JSON.stringify({ id, name, parent, email }));

    } else {

    }
  };
  const data2 = useMemo(() => {
    return dnparentdata && dnparentdata?.map((org) => ({
      id: org.id,
      name: org.name,
      department_name: org.department_name,
      organization_name: org.organization_name,
      report_to_name: org.report_to_name,
      status: org.status,
      organization_id: org.organization_id,
      depart_id: org.department_id,
      report_to_id: org.report_to_id,
      handleRowClick: handleRowClick
    }));
  }, [dnparentdata])
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(8);
  const getorgdataa = async () => {
    const url = "administration/organizations/";
    const response = await getData(url);
    if (response) {

      setorgdata(response);


    }

  }
  const getorgdata = async (page = 1) => {

    const url = `administration/designations-no-pagination/`;
    const response = await getData(url);

    if (response) {
      setdnparentdata(response);
      setTotalCount(response.count);
      setSelectedOrgDetails(response[0]);
      getdeptdata(response[0]?.id)
    }
  };
  const handleSearch = (query) => {
    setSearchQuery(query);
  };
  const filteredData = useMemo(() => {
    if (!searchQuery) {
      return data2;
    }
    return data2.filter((org) =>
      org.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      org.department_name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      org.organization_name.toLowerCase().includes(searchQuery.toLowerCase())

    );
  }, [searchQuery, dnparentdata]);
  const handleStatus = async (row) => {

    const newStatus = !row.original.status;
    row.original.status = newStatus;
    const orgData = row.original;

    const url = `administration/organizations/${orgData.organization_id}/departments/${orgData.depart_id}/designations/${orgData.id}`
    const response = await patchData(url, { status: newStatus });

    if (response) {
      getorgdata()
    }

  };
  const handlePageChangenext = async (selectedPage, setCurrentPage) => {


    const nextpage = selectedPage + 1;
    setCurrentPage(nextpage)
    const url = `administration/designations/?page=${nextpage}`;
    const response = await getData(url);
    if (response) {
      setdnparentdata(response.results);
      setTotalCount(response.count);
    }
  };
  const handlePageChangeprev = async (selectedPage) => {

    const prev = selectedPage - 1;
    setCurrentPage(prev)
    const url = `administration/designations/?page=${prev}`;
    const response = await getData(url);
    if (response) {
      setdnparentdata(response.results);
      setTotalCount(response.count);
    }
  };
  const getdeptdata = async (res) => {
    setparentorgid(res);

    const url = `administration/organizations/${res}/departments/`;
    const response = await getData(url);
    if (response) {
      setdepartmentdetails(response);
    }

  }
  const getcountry = async () => {
    const url = "administration/countries/";
    const response = await getData(url);
    setcountrydata(response)

  }
  const handlelocationdata = async (e) => {
    const value = e.target.value;
    const name = e.target.name;

    if (name === "country") {
      setcountryId(value)

      try {
        const url = `administration/countries/${value}/states/`

        const response = await getData(url);

        if (response) {
          setstatedata(response)
        }
      } catch (error) {

      }
    }
    else if (name === 'state') {
      setstateid(value)
      try {
        const url = `administration/countries/${countryId}/states/${value}/cities/`

        const response = await getData(url);

        if (response) {
          setcitydata(response)
        }
      } catch (error) {

      }
    }
    else if (name === 'city') {
      setcityid(value)
    }
  }
  const handleChange = (e) => {
    const { name, value } = e.target;
    setorgform(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  const handleChangedept = async (e) => {
    const { name, value } = e.target;
    if (name === 'name') {
      setdeptform(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
    else if (name === 'parentorgidog') {
      setparentidfromorg(value);
      const urldept = `administration/organizations/${value ? value : parentidfromorg}/departments/`;
      const response = await getData(urldept);
      if (response) {
        setdepartmentfromorg(response)
      }
    }
    else if (name === 'department') {
      setdepartmentidfromorg(value);
      const urlreportto = `administration/organizations/${parentidfromorg ? parentidfromorg : deptform.orgid}/departments/${value}/designations/`
      const response2 = await getData(urlreportto);
      setreporttofromorg(response2)

    }
    else if (name === 'reporttoid') {
      setdeptform(prevState => ({
        ...prevState,
        [name]: value
      }));
    }
  }
  const handleSubmit = async () => {
    const finalobj = {
      name: deptform.name,
      report_to_id: deptform.reporttoid || null
    }
    if (deptform.name.length > 0) {
      const url = `administration/organizations/${parentidfromorg}/departments/${departmentidfromorg}/designations/`

      const response = await Postdata(url, finalobj);
      if (!response.error) {
        displayToast('Designation Added Successfully', 'success');
        closeModal();
        getorgdata()

      }
      else {
        displayToast(response.error, 'danger');
      }
    }
    else {
      displayToast('Fill all the required details', 'danger');
    }

  }
  const handleSubmitdept = async () => {
    const finalobj = {
      name: deptform.name,
      parent_department_id: null,
      country_code: "+91",
      area_code: '1',
      landline: deptform.landline,
      mobile: deptform.mobile,
      email: deptform.email
    }
    const url = `administration/organizations/${parentorgid}/departments/`;
    const response = Postdata(url, finalobj);
    if (!response.error) {
      getdeptdata()
    }

  }
  const handleFilterClick = () => {
    // onFilter(searchQuery); 
  };
  const openModal = () => {
    setIsModalOpen(true);
  };
  const closeModal = () => {
    setIsModalOpen(false);
    handleCleardept();
  };
  const openModaldept = () => {
    setIsModalOpendept(true);
  };
  const closeModaldept = () => {
    setIsModalOpendept(false);
  };
  const submitclose = () => {
    setsubmit(false);
  };

  const handleEdit = async (row) => {
    const orgData = row.original;

    setdeptform({
      id: orgData.id,
      name: orgData.name,
      orgid: orgData.organization_id,
      deptid: orgData.depart_id,
      reporttoid: orgData.report_to_id,
      status: orgData.status
    })
    setdepartmentidfromorg(orgData.depart_id);
    const urldept = `administration/organizations/${orgData.organization_id}/departments/`;
    const response = await getData(urldept);
    if (response) {
      setdepartmentfromorg(response)
      const urlreportto = `administration/organizations/${orgData.organization_id}/departments/${orgData.depart_id}/designations/`
      const response2 = await getData(urlreportto);

      setreporttofromorg(response2)
    }

    openModal();
    setUpdatebtn(true);
  };
  const handleUpdate = async () => {
    const finalobj = {

      name: deptform.name,
      report_to_id: deptform.reporttoid || null,
      status: deptform.status
    }

    const url = `administration/organizations/${deptform.orgid}/departments/${deptform.deptid}/designations/${deptform.id}/`
    const response = await updateData(url, finalobj);
    if (!response.error) {
      getorgdata();
      setUpdatebtn(false);
      closeModal();
    } else {
      displayToast(response.error?.[0] || "Something went wrong", 'danger');
    }

  }

  const handleCleardept = () => {
    setdeptform({
      id: null,
      name: "",
      orgid: null,
      deptid: null,
      reporttoid: null,


    })
    setparentidfromorg(null);
    setdepartmentidfromorg(null);
    setUpdatebtn(false);
  }

  const columns = useMemo(
    () => [
      // {
      //   Header: <input type='checkbox' />,
      //   accessor: 'checkbox',
      //   Cell: ({ row }) => (
      //     <input type="checkbox" checked={row.isSelected} onChange={() => row.toggleRowSelected()} />
      //   ),
      // },
      {
        Header: 'Designation ',
        accessor: 'name',
        Cell: ({ row }) => (
          <div style={{ cursor: 'pointer', height: "100%", display: 'flex', alignItems: 'center' }} onClick={() => { handleRowClick(row.original.id, row) }}>
            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.name}</p>
          </div>
        )
      },

      {
        Header: 'Department',
        accessor: 'parent',
        Cell: ({ row }) => (
          <div >
            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.department_name}</p>
          </div>
        )
      },
      {
        Header: 'Institute',
        accessor: 'email',
        Cell: ({ row }) => (
          <div >
            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.organization_name}</p>
          </div>
        )
      },
      {
        Header: 'Reporting To',
        accessor: 'reporting',
        Cell: ({ row }) => (
          <div >
            <p style={{ textAlign: 'left', color: '#222F3E', fontWeight: 500, margin: 0 }}>{row.original.report_to_name}</p>
          </div>
        )
      },
      {
        Header: 'Action',
        Cell: ({ row }) => (
          <div style={{ display: 'flex', gap: '10px' }}>
            <div class="form-check form-switch custom-switch" >
              <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" style={{ cursor: 'pointer' }} checked={row.original.status} onChange={() => handleStatus(row)} />
            </div>
            <img src={edit} style={{ cursor: 'pointer' }} onClick={() => handleEdit(row)}></img>
          </div>
        ),
      },

    ],
    []
  );
  useEffect(() => {
    getorgdata();
    getcountry();
    getdeptdata();
    getorgdataa();

  }, [])


  const pageCount = Math.ceil(totalCount / itemsPerPage);
  return (
    <>
      <div style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
        position: "relative",
      }}>

        {/* ✅ FIXED: Title + Add Button */}
        <div style={{ flexShrink: 0, padding: "0 12px" }}>
          <div style={{ display: "flex", justifyContent: 'space-between', alignItems: 'center' }}>
            <h2 className='main-heading'>Designations</h2>
            <button className='add-btn' onClick={() => openModal()}>
              <span className='me-2'>
                <svg width="12" height="12" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M20.4286 13.3537H12.5714V21.2108C12.5714 21.6276 12.4059 22.0273 12.1112 22.322C11.8165 22.6167 11.4168 22.7822 11 22.7822C10.5832 22.7822 10.1835 22.6167 9.88883 22.322C9.59413 22.0273 9.42857 21.6276 9.42857 21.2108V13.3537H1.57143C1.15466 13.3537 0.754961 13.1881 0.460261 12.8934C0.165561 12.5987 0 12.199 0 11.7822C0 11.3655 0.165561 10.9658 0.460261 10.6711C0.754961 10.3764 1.15466 10.2108 1.57143 10.2108H9.42857V2.35366C9.42857 1.93689 9.59413 1.53719 9.88883 1.24249C10.1835 0.947787 10.5832 0.782227 11 0.782227C11.4168 0.782227 11.8165 0.947787 12.1112 1.24249C12.4059 1.53719 12.5714 1.93689 12.5714 2.35366V10.2108H20.4286C20.8453 10.2108 21.245 10.3764 21.5397 10.6711C21.8344 10.9658 22 11.3655 22 11.7822C22 12.199 21.8344 12.5987 21.5397 12.8934C21.245 13.1881 20.8453 13.3537 20.4286 13.3537Z" fill="white" />
                </svg>
              </span>
              Add New Designation
            </button>
          </div>
        </div>

        {/* ✅ FIXED: Search + Filter */}
        <div style={{ flexShrink: 0, padding: "8px 12px" }}>
          <div style={{ display: "flex", justifyContent: 'end' }}>
            <SearchBar data={dnparentdata} onSearch={handleSearch} />
            <button className="filter-btn" onClick={handleFilterClick}>
              <img src={filtericon} />
            </button>
          </div>
        </div>

        {/* ✅ SCROLLABLE BODY: Table (left) + Side Panel (right) */}
        <div style={{
          display: "flex",
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
          padding: "0 12px",
        }}>

          {/* LEFT: Table — only tbody scrolls */}
          <div style={{
            flex: "0 0 75%",
            maxWidth: "75%",
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            overflow: "hidden",
            paddingRight: "12px",
          }}>
            
              <Table
                data={filteredData}
                columns={columns}
                selectedOrgDetails={selectedOrgDetails}
                pageCountFromBackend={pageCount}
              />
            
          </div>

          {/* RIGHT: Side Panel */}
          <div style={{
            flex: "0 0 25%",
            maxWidth: "25%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}>
            <RolesAndPermissionsShortDetails
              navigate={navigate}
              closeModaldept={closeModaldept}
              isModalOpendept={isModalOpendept}
              openModaldept={openModaldept}
              selectedOrgDetails={selectedOrgDetails}
              departmentdetails={departmentdetails}
              deptform={deptform}
              handleChangedept={handleChangedept}
              handleSubmitdept={handleSubmitdept}
            />
          </div>
        </div>

      </div>
      <div>
        <AddDesignationModal isOpen={isModalOpen} onClose={closeModal} setsubmit={setsubmit} dnparentdata={dnparentdata} handleSubmit={handleSubmit} deptform={deptform}
          handleChangedept={handleChangedept} departmentfromorg={departmentfromorg} reporttofromorg={reporttofromorg} parentidfromorg={parentidfromorg} departmentidfromorg={departmentidfromorg}
          handleUpdate={handleUpdate} Updatebtn={Updatebtn} orgdata={orgdata} />
      </div>
      {showToast && (
        <div
          className={`custom-toast toast align-items-center text-white bg-${toastVariant} border-0 position-fixed top-0 end-0 m-3`}
          role="alert"
          style={{
            display: 'block',
            minWidth: '300px',
            maxWidth: '400px',
            borderRadius: '8px',
            boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
            fontSize: '15px',
            zIndex: 9999
          }}
        >
          <div className="d-flex">
            <div className="toast-body" style={{ padding: '12px 16px' }}>
              <strong>{toastVariant === 'success'} </strong> {toastMessage}
            </div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              onClick={() => setShowToast(false)}
              aria-label="Close"
            ></button>
          </div>
        </div>

      )}
      {submit === true ? <SuccessfulPopup mainheading={'Registration Completed Successfully!'} submitclose={submitclose} /> : ''}
    </>
  );
};

export default RolesAndPermissions;
